import React from "react";
import PropTypes from "prop-types";

import { DeleteButton, SaveDraftButton, PublishButton } from ".";

export const ProjectFormMenuFixed = ({
  deleteProject,
  saveDraft,
  publishProject,
  publishDisabled,
  deleteDisabled,
}) => {
  return (
    <>
      <DeleteButton
        deleteProject={deleteProject}
        dataLabel="project-delete"
        disabled={deleteDisabled}
        isFixed
      />

      <SaveDraftButton
        saveDraft={saveDraft}
        message="projects.new.save_draft.button"
        dataLabel="project-save-draft"
        isFixed
      />

      <PublishButton
        publishProject={publishProject}
        disabled={publishDisabled}
        message="projects.new.publish.button"
        dataLabel="project-publish"
      />
    </>
  );
};

ProjectFormMenuFixed.propTypes = {
  deleteProject: PropTypes.func,
  saveDraft: PropTypes.func,
  publishProject: PropTypes.func,
  publishDisabled: PropTypes.bool,
  deleteDisabled: PropTypes.bool,
};

ProjectFormMenuFixed.defaultProps = {
  deleteProject: () => {},
  saveDraft: () => {},
  publishProject: () => {},
  publishDisabled: false,
  deleteDisabled: false,
};

export default ProjectFormMenuFixed;
